import { render, staticRenderFns } from "./QuotationModelEdit.vue?vue&type=template&id=64bd7235&scoped=true"
import script from "./QuotationModelEdit.vue?vue&type=script&lang=js"
export * from "./QuotationModelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bd7235",
  null
  
)

export default component.exports